<template>
  <div
    class="mypage-pc-menu_cover"
    @click="hideMenuCover"
    :class="isMypagePcMenuOpen ? 'animated' : ''">

    <div>
      <ul v-if="customClaim.isClient">
        <li class="little-large_label">クライアントマイページ</li>
        <router-link :to="{name: 'CreatingWork'}">
          <li>新規発注</li>
        </router-link>
        <router-link :to="{name: 'RetrievingWorks'}">
          <li>案件一覧</li>
        </router-link>
      </ul>
      <ul v-if="customClaim.isOperator">
        <li class="little-large_label">オペレーターマイページ</li>
        <router-link :to="{name: 'UpdatingOperator'}">
          <li>新規受注・登録時間変更</li>
        </router-link>
        <li @click="onClickMatching">受注案件管理</li>
        <router-link :to="{name: 'PaymentTop'}">
          <li>入金情報</li>
        </router-link>
      </ul>
      <ul>
        <li class="little-large_label">その他</li>
        <router-link :to="{name: 'UserDetail'}">
          <li>ユーザー情報確認</li>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import animation from "@/assets/js/functions/_core/animation";
  import store from "@/store";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "MypagePcMenuCover",

    mixins: [animation, collection],

    data() {
      return {
        matching: {}
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid', isMypagePcMenuOpen: 'cover/isMypagePcMenuOpen', customClaim: 'auth/customClaim'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    methods: {
      hideMenuCover() {
        if (!this.isMypagePcMenuOpen) return;
        store.dispatch('cover/toggleMypagePcMenuCover')
      },

      isExistMatching(matching) {
        return !!matching && !!matching.status;
      },
      isNewestMatchingWaiting(matching) {
        return (this.isExistMatching(matching) && matching.status === 'waiting');
      },
      isNewestMatchingActive(matching) {
        return (this.isExistMatching(matching) && matching.status !== 'waiting');
      },

      async onClickMatching() {
        await this.getDoc(COLLECTION_NAMES.OPERATORS, this.uid).then(async doc => {
          this.operator = doc;
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });

        const operatorPath = this.getDocPath(COLLECTION_NAMES.OPERATORS, this.uid);
        const query = this.getDocRef(COLLECTION_NAMES.MATCHINGS).where(
          "isDeleted", "==", false
        ).where(
          'operator', '==', operatorPath
        ).orderBy('createdAt', "desc").limit(1);
        await this.retrieveDocs(query).then(docs => {
          this.matching = docs[0] ? docs[0] : {};
        });

        if (this.isNewestMatchingWaiting(this.matching)) {
          this.$router.push({name: 'MatchingDetail', params: {matchingId: this.matching.id}});
        } else if (this.isNewestMatchingActive(this.matching)) {
          this.$router.push({name: 'Meeting', params: {matchingId: this.matching.id}});
        }
        return null;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .mypage-pc-menu_cover {
    @include cover;
    @extend .fade_in;
    background: none;

    display: flex;
    flex-flow: column;
    margin-top: 15vh;
    justify-content: flex-start;
    align-items: flex-end;

    > div {
      display: flex;
      justify-content: space-around;
      width: 50%;
      padding: 2rem 0;
      opacity: 0.8;
      background-color: $base_color;

      > ul {
        width: 30%;

        li {
          &:hover {
            color: $primary_color;
          }

          padding-bottom: 0.5rem;
        }
        li.little-large_label {
          color: $label_color;
        }
      }
    }
  }
</style>